import { cn } from "@/lib/utils";

interface CategoryChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export function CategoryChip({ label, active, onClick }: CategoryChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-full px-5 py-2.5 text-base font-medium transition-colors",
        active
          ? "bg-primary text-primary-foreground shadow-sm"
          : "bg-card text-foreground/70 hover:bg-muted",
      )}
    >
      {label}
    </button>
  );
}
